import { render, staticRenderFns } from "./ApirestTable.vue?vue&type=template&id=ad87f07a&scoped=true&"
import script from "./ApirestTable.vue?vue&type=script&lang=js&"
export * from "./ApirestTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad87f07a",
  null
  
)

export default component.exports